import qs from 'qs'
import * as R from 'ramda'
import React from 'react'
import { Redirect } from 'react-router-dom'
import URI from 'urijs'

import { getLoginStatus } from './userHelper'

type Props = {
  location: {
    pathname: string
    search: string
  }
} & any

const withLogin = (WrappedComponent: any) => ({
  location,
  ...props
}: Props) => {
  const { pathname, search } = location
  const { isLoggedIn, error } = getLoginStatus()
  const isLoginPage = R.equals(pathname, '/login')
  const isNoCookie = R.equals(error, 'UNDEFINED_JWT_ERROR')

  if (!isLoggedIn && !isLoginPage && isNoCookie) {
    return (
      <Redirect
        to={{
          pathname: '/login',
          state: {
            redirectUrl: URI.encode(`${pathname}${search}`)
          }
        }}
      />
    )
  } else if (isLoggedIn && isLoginPage) {
    const redirectUri = new URI(
      qs.parse(search, {
        ignoreQueryPrefix: true
      }).redirectUrl || '/'
    )
    return (
      <Redirect
        to={{ pathname: redirectUri.pathname(), search: redirectUri.search() }}
      />
    )
  }

  return <WrappedComponent {...props} />
}

export default withLogin
